import { render, staticRenderFns } from "./ys-aside-right.vue?vue&type=template&id=2f87c6b5&scoped=true"
import script from "./ys-aside-right.vue?vue&type=script&lang=js"
export * from "./ys-aside-right.vue?vue&type=script&lang=js"
import style0 from "./ys-aside-right.vue?vue&type=style&index=0&id=2f87c6b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87c6b5",
  null
  
)

export default component.exports